/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Ingredient_UnitInputs */

const en_editor_ingredient_unit = /** @type {(inputs: Editor_Ingredient_UnitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unit`)
};

const de_editor_ingredient_unit = /** @type {(inputs: Editor_Ingredient_UnitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einheit`)
};

/**
* | output |
* | --- |
* | "Unit" |
*
* @param {Editor_Ingredient_UnitInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const editor_ingredient_unit = /** @type {((inputs?: Editor_Ingredient_UnitInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Ingredient_UnitInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_editor_ingredient_unit(inputs)
	return en_editor_ingredient_unit(inputs)
});